
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Answer } from '@/types/delivery'
import Filelist from '@/components/media/Filelist.vue'

@Component({
  components: { Filelist }
})

export default class DeliveryShowResultIssues extends Vue {
  @Prop() answer!:Answer

  settings = {
    routeNames: { list: 'deliveries', show: 'deliveryShow', edit: 'deliveryEdit' },
    routeParamKey: 'deliveryId',
    functionNames: { setCurrent: 'setCurrentDelivery', save: 'saveDelivery' },
    getterNames: { current: 'currentDelivery', loading: 'loadingDelivery', errors: 'deliveryErrors' }
  }

  showPreviewModal = false
  file:{ id:number, url:string, name:string, mime_type:string, size:string, note:string|null, created_at:string }|null = null

  togglePreviewModal (file:{ id:number, url:string, name:string, mime_type:string, size:string, note:string|null, created_at:string }|null) : void {
    if (!this.showPreviewModal && file) {
      if (file.mime_type === 'application/pdf') {
        window.open(file.url, '_blank')
      } else {
        this.file = file
        this.showPreviewModal = true
      }
    } else {
      this.file = null
      this.showPreviewModal = false
    }
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }
}
